$(document).ready(function () {
  var winLocation = window.location.href;

  function deliveryDay() {
    var classes = {
      fields: ".property-fields__cheks.field-delivery-date input",
      fieldsChecked:
        ".property-fields__cheks.field-delivery-date input:checked",
      input:
        '.property-fields__cheks.field-delivery-date [name="properties[Day for delivery]"]',
    };

    if ($(classes.fields).length > 0) {
      $(classes.fields).change((e) => {
        var options = [];

        $(classes.fieldsChecked).each((i, el) => {
          options.push($(el).val());
        });

        var result = options.join(",");
        $(classes.input).val(result);
      });
    }
  }

  function accordeon() {
    const selectors = {
      item: ".accordeon__item",
      question: ".accordeon__question",
      header: ".accordeon__header",
      answer: ".accordeon__answer",
    };

    $(selectors.item)
      .eq(0)
      .toggleClass("active")
      .find(selectors.answer)
      .slideToggle();

    $(selectors.question).on("click", (e) => {
      if ($(e.currentTarget).parents(selectors.item).hasClass("active")) {
        $(e.currentTarget).parents(selectors.item).removeClass("active");
        $(e.currentTarget)
          .parents(selectors.item)
          .find(selectors.answer)
          .slideUp();
      } else {
        $(selectors.answer).slideUp();
        $(selectors.item).removeClass("active");
        $(e.currentTarget).parents(selectors.item).addClass("active");
        $(e.currentTarget)
          .parents(selectors.item)
          .find(selectors.answer)
          .slideDown();
      }
    });
  }

  function handleActiveAnswer() {
    const dataSet = {
      dataItems: "[data-item-count]",
      activeClass: "active",
    };
    if ($(dataSet.dataItems).length) {
      $(dataSet.dataItems).on("click", function (e) {
        $(dataSet.dataItems).removeClass(dataSet.activeClass);
        $(this).addClass(dataSet.activeClass);
      });
    }
  }

  function hahdlePhoneNumber() {
    const currentPhone = $(".template-cart #recipient-phone");

    currentPhone.intlTelInput({
      nationalMode: false,
      numberType: "DESKTOP",
      separateDialCode: true,
      preferredCountries: ["sg"],
    });
  }

  function forceRefreshWhenBack() {
    window.addEventListener("pageshow", (event) => {
      if (event.persisted) {
        // Page was loaded from bfcache — force a reload
        window.location.reload();
      }
    });
  }

  forceRefreshWhenBack();

  hahdlePhoneNumber();
  handleActiveAnswer();
  deliveryDay();
  accordeon();
});

function addOneItemToCart(variantToAdd) {
  let formData = {
    items: [
      {
        id: variantToAdd.id,
        selling_plan: variantToAdd.selling_plan,
        quantity: variantToAdd.quantity,
      },
    ],
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function clearCart() {
  fetch(window.Shopify.routes.root + "cart/clear.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });

  // let variantToRemove = {
  //   id: 50924006342956,
  //   quantity: 0,
  // };

  // removeOneItemInCart(variantToRemove);
  // reloadPage();
}

function removeOneItemInCart(variantToUpdate) {
  let formData = {
    updates: {
      id: variantToUpdate.id,
      quantity: variantToUpdate.quantity,
    },
  };

  fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
}

function reloadPage() {
  window.location.reload();
}
